/**
 * TBB bio "Show more" toggle — shared by the seller and collector
 * profile cards.
 *
 * How it works:
 * - The bio <p> carries [data-bio-clamp] and the CSS class
 *   `.tbb-bio-clamp`, which line-clamps it to 3 lines.
 * - The sibling button [data-bio-toggle] starts [hidden]. We only
 *   reveal it when the clamped text actually overflows (scrollHeight
 *   beats clientHeight), so short bios never grow a pointless link.
 * - Both cards hydrate their bio text via JS AFTER first paint
 *   (PV description on seller, worker profile on collector), so a
 *   one-shot measurement would lie. A MutationObserver re-measures
 *   whenever the bio's text changes, and a debounced resize listener
 *   re-measures when the viewport (and therefore line wrapping) moves.
 *
 * No dependencies. Safe to load on pages with zero bio elements.
 */
(function () {
  'use strict';

  var EXPANDED_CLASS = 'is-expanded';
  var LABEL_MORE = 'Show more';
  var LABEL_LESS = 'Show less';

  function setup(bio) {
    // The toggle button is the next [data-bio-toggle] inside the same parent.
    var toggle = bio.parentElement
      ? bio.parentElement.querySelector('[data-bio-toggle]')
      : null;
    if (!toggle) return;

    function measure() {
      // Never measure while expanded — an expanded bio can't overflow,
      // and hiding the toggle then would strand the user with no
      // "Show less". Only re-evaluate in the clamped state.
      if (bio.classList.contains(EXPANDED_CLASS)) return;
      var overflows = bio.scrollHeight > bio.clientHeight + 1; // +1 absorbs subpixel rounding
      if (overflows) {
        toggle.removeAttribute('hidden');
      } else {
        toggle.setAttribute('hidden', '');
      }
    }

    toggle.addEventListener('click', function () {
      var expanded = bio.classList.toggle(EXPANDED_CLASS);
      toggle.textContent = expanded ? LABEL_LESS : LABEL_MORE;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (!expanded) measure(); // text may have shrunk while expanded (hydration)
    });
    toggle.setAttribute('aria-expanded', 'false');

    // Re-measure when hydration swaps the bio text in.
    new MutationObserver(measure).observe(bio, {
      childList: true,
      characterData: true,
      subtree: true
    });

    // Re-measure on resize — wrapping changes with viewport width.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 150);
    });

    measure();
  }

  function init() {
    var bios = document.querySelectorAll('[data-bio-clamp]');
    for (var i = 0; i < bios.length; i++) setup(bios[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
